export default __webpack_public_path__ + "static/media/christopher.9decca57.jpg";